export const DISAPPROVE_REASON_CHIPS = [
  'video_from_unapproved_channel',
  'missing_hashtag',
  'off_brief',
  'missing_watermark',
  'other',
] as const;

export function resolveDisapproveReason({
  chip,
  otherText,
}: {
  chip: string | null;
  otherText: string;
}): { ok: true; reason: string } | { ok: false; code: 'reason_required' } {
  if (chip && chip !== 'other') return { ok: true, reason: chip };
  const text = otherText.trim().slice(0, 500);
  if (chip === 'other' && text) return { ok: true, reason: text };
  return { ok: false, code: 'reason_required' };
}
